__turbopack_context__.v({
  "label": "P-module-sass-module__nuSbUa__label",
  "label--filled": "P-module-sass-module__nuSbUa__label--filled",
  "label--scrolled": "P-module-sass-module__nuSbUa__label--scrolled",
  "p": "P-module-sass-module__nuSbUa__p",
  "p--editable": "P-module-sass-module__nuSbUa__p--editable",
  "p--placeholder": "P-module-sass-module__nuSbUa__p--placeholder",
});
